import cert1 from "../assets/certificate/cert1.jpg";
import cert2 from "../assets/certificate/cert2.jpg";
import project0 from "../assets/certificate/project0.jpg";
import project1 from "../assets/certificate/project1.jpg";

import pic5 from "../assets/slideshow/pic5.jpg";
import pic2 from "../assets/slideshow/pic2.jpg";
import pic3 from "../assets/slideshow/pic3.jpg";
import pic4 from "../assets/slideshow/pic4.jpg";
export const dataSlider = [
  {
    id: 1,
    // type: "",
    // title: "Javascript ES6",
    // source: "Udemy",
    // repo: "",
    // deployed: "",
    img: pic5,
    category: "APPARELS",
  },
  {
    id: 2,

    img: pic2,
    category: "STREET FOODS",
  },
  {
    id: 3,

    img: pic3,
    category: "DAILY DISH",
  },
  {
    id: 4,

    img: pic4,
    category: "ESSENTIALS",
  },
];
